import { string, z } from "zod";
export const farmAdviceFeedbackActionDtoSchema = z.union([z.literal("agree"), z.literal("disagree")]);
export const farmAdviceFeedbackDtoSchema = z.object({
    id: z.string(),
    applicationId: z.string(),
    farmLicenseKey: z.string(),
    adviceId: z.string(),
    solutionId: z.string(),
    userId: z.string(),
    userName: z.string(),
    action: farmAdviceFeedbackActionDtoSchema.nullable(),
    text: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const upsertFarmAdviceFeedbackDtoSchema = z.object({
    feedbackId: string().optional(),
    solutionId: z.string(),
    action: farmAdviceFeedbackActionDtoSchema.nullable(),
    text: z.string().nullable(),
});
//# sourceMappingURL=farm-advice-feedback.schema.js.map